module.exports = __webpack_public_path__ + "static/media/preview@768.2ad2c2e8.png";